import intersect from "@alpinejs/intersect";
import Alpine from "alpinejs";
import Accordion from "../modules/Accordion";
import setupCartAddedMessageOverride from "../modules/CartAddedMessageOverride";
import CompareTable from "../modules/CompareTable";
import DateTimeUtils from "../modules/DateTimeUtils";
import HeaderNavigation from "../modules/HeaderNavigation";
import ProductDetailPage from "../modules/ProductDetailPage";
import ProductRegistrationForm from "../modules/ProductRegistrationForm";
import ProductVariants from "../modules/ProductVariants";
import PromotionHandler from "../modules/PromotionHandler";
import RebuyStore from "../modules/RebuyStore";
import VariantDisplayBadges from "../modules/VariantDisplayBadges";

window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.data("ProductRegistrationForm", ProductRegistrationForm);
Alpine.data("Accordion", Accordion);
Alpine.data("VariantDisplayBadges", VariantDisplayBadges);
Alpine.data("HeaderNavigation", HeaderNavigation);
Alpine.data("DateTimeUtils", DateTimeUtils);
Alpine.data("PromotionHandler", PromotionHandler);
Alpine.data("ProductVariants", ProductVariants);
Alpine.data("ProductDetailPage", ProductDetailPage);
Alpine.data("CompareTable", CompareTable);

Alpine.store("rebuy", RebuyStore());

setupCartAddedMessageOverride();

Alpine.start();
